// Has the light in force moved enough to be worth re-presenting?
// Notes: ~/comments/aos-threejs-poc/lightWatch_nothing_re_presents.md

import { combineLight, type LightProbeLike } from "../inference/sceneLightSh.ts";
import type { Vector3 } from "../math/index.ts";
import { RELIGHT_SH_DRIFT, sh27Drift } from "../inference/pbrShadeParams.ts";

export interface LightWatch {
  /** True when the light at `at` differs from the one this last reported on. */
  moved(root: unknown, at: Vector3, probe: LightProbeLike | null | undefined): boolean;
  /** The light it last reported on, for a debug seam. Reused; do not keep it. */
  readonly last: Float32Array;
}

/** The light's own watcher, the sibling of the camera watch. The first look always moves. */
export function createLightWatch(): LightWatch {
  const current = new Float32Array(27);
  const last = new Float32Array(27);
  const probeScratch = new Float32Array(27);
  let seen = false;
  return {
    last,
    moved(root, at, probe) {
      combineLight(current, root, at, probe, probeScratch);
      const drift = seen ? sh27Drift(current, last) : Infinity;
      if (drift < RELIGHT_SH_DRIFT) return false;
      last.set(current);
      seen = true;
      return true;
    },
  };
}
